// Preserve the existing 20-character upper bound; require all three categories.
export const passwordRuleMessage = '密码须为10-20位，且同时包含字母、数字和符号';
export const passwordPattern = /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[^A-Za-z0-9\s])[!-~]{10,20}$/;
export const getPasswordChecks = (value: string) => {
  const letter = /[A-Za-z]/.test(value);
  const number = /[0-9]/.test(value);
  const symbol = /[^A-Za-z0-9\s]/.test(value) && /^[!-~]*$/.test(value);
  return {
    length: value.length >= 10,
    letter,
    number,
    symbol,
    categories: Number(letter) + Number(number) + Number(symbol),
  };
};
